import React from 'react';
import { Link } from 'react-router-dom';

/**
 * E1 — shared chrome for real, public, standalone legal pages.
 *
 * Replaces the previous modal-based approach (PolicyModal.js, removed
 * this phase) where privacy/terms/cookie content had no URL a crawler,
 * Google Play, or a customer could link to, and contained literal
 * "TEMPORARY CONTENT - TO BE UPDATED" text. These pages are real routes,
 * reachable without authentication, and meant to be indexed.
 */
export default function LegalPageLayout({ title, lastUpdated, children }) {
  return (
    <div className="min-h-screen bg-[#0a0e27] text-white">
      <header className="border-b border-white/10">
        <div className="max-w-3xl mx-auto px-6 py-6 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <img src="/logo-new.png" alt="Sheba Smart Home" className="h-10 w-auto" />
          </Link>
          <Link to="/" className="text-sm text-white/60 hover:text-[#00d4ff] transition-colors">
            ← Back to home
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-12">
        <h1 className="text-3xl font-bold mb-2">{title}</h1>
        {lastUpdated && (
          <p className="text-sm text-white/40 mb-10">Last updated: {lastUpdated}</p>
        )}
        <div className="prose prose-invert max-w-none space-y-6 text-white/80 leading-relaxed">
          {children}
        </div>
      </main>

      <footer className="border-t border-white/10 py-8 text-center text-sm text-white/40">
        <Link to="/privacy-policy" className="hover:text-[#00d4ff] mx-2">Privacy Policy</Link>
        <Link to="/terms" className="hover:text-[#00d4ff] mx-2">Terms</Link>
        <Link to="/support" className="hover:text-[#00d4ff] mx-2">Support</Link>
        <Link to="/account-deletion" className="hover:text-[#00d4ff] mx-2">Delete Account</Link>
      </footer>
    </div>
  );
}
